import { cwslapi } from "../index";

// 首页名人堂数据 —— 排行管理
export const getIndexFamousRankApi = (data) => { 
  return cwslapi({
    url: "/rank/getIndexFamousRank",
    method: "post",
    data,
  });
};


// 名人堂全部数据 —— 排行管理
export const getFamousRankApi = (data) => { 
  return cwslapi({
    url: "/rank/getFamousRank",
    method: "post",
    data,
  });
};

